<template>
  <aside class="controls__lower">
    <div class="controls__container">
      <slideshowController
        :gtm="gtm + ' / prev'"
        :focusOnMount="false"
        :enabled="hasPreviousSlide"
        className="controls__previous-next--overlay"
        label="Previous slide"
        svgName="icon__arrow--20--stroke.svg"
        svgClass="controls__link__svg--arrow--180"
        @action="$emit('previous')"
        />

      <slideshowController
        :gtm="gtm + ' / next'"
        :focusOnMount="false"
        :enabled="hasNextSlide"
        className="controls__previous-next--overlay"
        label="Next slide"
        svgName="icon__arrow--20--stroke.svg"
        svgClass="controls__link__svg--arrow"
        @action="$emit('next')"
        />
    </div>
  </aside>
</template>

<script>
  import slideshowController from './controller.vue';

  export default {
    components: {
      slideshowController,
    },

    props: {
      gtm: { type: String, required: true },
      hasPreviousSlide: { type: Boolean, required: true },
      hasNextSlide: { type: Boolean, required: true },
    },
  };
</script>
